function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fill-gradient",
  x1: 0.653,
  y1: 2.203,
  x2: 0.34,
  y2: -1.046,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c8cadb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9399b5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_35053",
  "data-name": "Group 35053"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7041",
  "data-name": "Ellipse 7041",
  cx: 35,
  cy: 35,
  r: 35,
  fill: "#eaeaf3"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_35055",
  "data-name": "Group 35055"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_35054",
  "data-name": "Group 35054"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63243",
  "data-name": "Path 63243",
  d: "M16.1,55.5a1.58,1.58,0,0,1-1.6-1.6V19.5h41V53.9a1.58,1.58,0,0,1-1.6,1.6Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63244",
  "data-name": "Path 63244",
  d: "M55,20V53.9A1.11,1.11,0,0,1,53.9,55H16.1A1.11,1.11,0,0,1,15,53.9V20H55m1-1H14V53.9A2.051,2.051,0,0,0,16.1,56H53.9A2.112,2.112,0,0,0,56,53.9V19Z",
  fill: "#b2b6cc"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_63245",
  "data-name": "Path 63245",
  d: "M53.9,13H16.1A2.163,2.163,0,0,0,14,15.3V20H56V15.3A2.163,2.163,0,0,0,53.9,13Z",
  fill: "url(#fill-gradient)"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7042",
  "data-name": "Ellipse 7042",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(16 15)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7043",
  "data-name": "Ellipse 7043",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(21 15)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7044",
  "data-name": "Ellipse 7044",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(26 15)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_35057",
  "data-name": "Group 35057"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_35056",
  "data-name": "Group 35056"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7045",
  "data-name": "Ellipse 7045",
  cx: 9,
  cy: 9,
  r: 9,
  transform: "translate(27 26)",
  fill: "#eaeaf3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63246",
  "data-name": "Path 63246",
  d: "M36,27a8,8,0,1,1-8,8,8.024,8.024,0,0,1,8-8m0-2A10,10,0,1,0,46,35,10.029,10.029,0,0,0,36,25Z",
  fill: "#9399b5"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_1001",
  "data-name": "Line 1001",
  x1: 7,
  y2: 7,
  transform: "translate(22 42)",
  fill: "none",
  stroke: "#9399b5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgNoOptions = function SvgNoOptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nooptions",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-options.7caad88e.svg";
export { ForwardRef as ReactComponent };